export var roleLookup={admin:'Administrator','sec-mngr':'Security Manager','asst-sec-mngr':'Assistant Security Manager',employee:'Employee'};/*
export const roleLabels = Object.entries(roleLookup).map(([key, value]) => {
  return { label: value, value: key };
});
*/